import React from 'react';
import styled from 'styled-components';
import { LinkedLogo } from 'email-templates/components/LinkedLogo';

export const LayoutFooter = (props: { className?: string }) => {
  return (
    <StyledFooter className={props.className || ''}>
      <StyledLogoSection>
        <img src={'/images/ceb-logo-2024.svg'} alt="CEB" />
      </StyledLogoSection>
      <StyledLegalSection>
        <ol>
          <li>
            <a href="https://ceb.com/privacy-policy">Privacy Policy</a>
          </li>
          <li>
            <a href="https://ceb.com/terms-and-conditions">
              Terms &amp; Conditions
            </a>
          </li>
        </ol>
        <p>Copyright © 2024 CEB. All rights reserved.</p>
      </StyledLegalSection>
      <StyledContactsSection>
        <ol>
          <li>
            <i className="fas fa-phone" />{' '}
            <a href="tel:18002323444">
              1 (800) <span>232-3444</span>
            </a>
          </li>
          <li>
            <i className="fas fa-phone" /> <strong>Tech:</strong>{' '}
            <a href="tel:18007509155">
              1 (800) <span>750-9155</span>
            </a>
          </li>
        </ol>
      </StyledContactsSection>
    </StyledFooter>
  );
};

const StyledFooter = styled.footer`
  background: var(--white);
  padding: 36px 64px;
  border-top: 1px solid var(--gray-200);
  background: var(--COLOR_CARARRA);
  display: flex;
  font-family: var(--FONT_SANS_SERIF);
  font-size: 15px;
  @media print {
    display: none;
  }
  > * {
    flex: 0 1 auto;
  }

  ol {
    list-style-type: none;
    padding: 0;
    margin: 0;
  }

  a,
  a:visited {
    color: inherit;
  }
`;

const StyledLogoSection = styled.div`
  flex: 0 1 auto;
  display: flex;
  align-items: center;
  img {
    width: 132px;
    display: block;
  }
  padding-right: 68px;
`;

const StyledLegalSection = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  color: var(--CEB_COLOR_BLACK_THREE);
  flex: 1 1 auto;
  align-items: center;
  ol {
    display: flex;
    flex-direction: row;
    gap: 16px;
    color: var(--COLOR_BLACK_THREE);
  }
  p {
    color: color-mix(in sRGB, var(--COLOR_BLACK), transparent 50%);
  }
`;

const StyledContactsSection = styled.div`
  text-align: right;
  display: flex;
  align-items: center;
  .fa-phone {
    transform: rotate(90deg);
    vertical-align: -2px;
  }
  line-height: 1.73;
`;
